import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ButtonTriggerEvent } from '../../../../common/components';
import { BaseComponent } from '../../../../common/components/base.component';
import { PlaceCategory } from '../../../../common/constants/constant';
import { getRouteUrl, routeConfigs } from '../../../../common/constants/route.config';
import { ModalService } from '../../../../common/services/modal.service';
import { HubEvent } from '../../../../models/hub/hub.event';
import { HubPlace } from '../../../../models/hub/hub.place';
import { ImageService } from '../../../../services/image.service';
import { PlaceDetailsModalComponent } from '../../place.details.modal/place.details.modal.component';
import { PlaceDetailsModalActions } from '../../place.details.modal/place.details.modal.provider';
import { TripDetailModalActions, TripDetailModalData } from '../../trip/trip.detail.modal/trip.detail.modal.provider';
import { TripDetailModalComponent } from '../../trip/trip.detail.modal/trip.detail.modal.component';
import { localStorageKeys } from '../../../../common/constants/local.storage.keys';
import { AllFrontendSettingsCommand } from '../../../../commands/visitor/all.frontend.settings.command';
import { PlaceService } from '../../../../services/place.service';

@Component({
  selector: 'ig-visitor-larger-card',
  templateUrl: './visitor.larger.card.component.html',
  styleUrls: ['./visitor.larger.card.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class VisitorLargerCardComponent extends BaseComponent implements OnInit {
  @Input() public item: HubEvent | HubPlace;
  public eventTimeText = '';
  public placeCategory = '';
  public hubName: string;
  public isNoImage = false;

  constructor(
    private router: Router,
    public imageService: ImageService,
    public modalService: ModalService,
    private activatedRoute: ActivatedRoute
  ) {
    super({activatedRoute});
  }

  public ngOnInit() {
    let {hubName} = this.allRouteParams;
    this.hubName = hubName;
    if (this.item.startTime) {
      this.eventTimeText = this.isMobile
        ? this.item.startTimeFormatted
        : `${this.item.startTimeFormatted}${this.item.endTimeFormatted ? ' - ' + this.item.endTimeFormatted : ''}`;
    } else {
      if (this.item['categoryList']) {
        this.placeCategory = '';
        let cate = '';
        for (let category of this.item['categoryList']) {
          cate += category + ', ';
          if (cate.length < 44) {
            this.placeCategory = cate;
          }
        }
        this.placeCategory = this.placeCategory.substr(0, this.placeCategory.length - 2);
      }
    }
    setTimeout(() => {
      if (!this.item.cover || !this.item.cover.source) {
        this.isNoImage = true;
      }
    });
  }

  public toReadable(code: string): string {
    return PlaceService.toReadableCategory(code);
  }

  public enterItemByKeyboard($event) {
    if ($event && $event.key === 'Enter') {
      this.showDetails();
    }
  }

  public showDetails() {
    if (this.item.isPromotionImage) {
      this.item.promotionLink = this.item.promotionLink.startsWith('http')
        ? this.item.promotionLink
        : 'http://' + this.item.promotionLink;
      window.open(this.item.promotionLink, '_blank');
      return;
    }

    if (!this.isMobile) {
      let actions = <PlaceDetailsModalActions>{
        confirm: (event: ButtonTriggerEvent, data: any) => {
        },
      };

      this.modalService.show({
        component: PlaceDetailsModalComponent,
        providers: [
          {provide: PlaceDetailsModalActions, useValue: actions},
          {provide: HubPlace, useValue: this.item},
        ],
        panelClass: 'modal-fixed-top',
      });
    } else {
      this.showDetailModalForMobile(this.item, 'place');
    }
  }

  public showDetailModalForMobile(item: any, displayingOn: string, isShowAddToTripBtn = false, index?: number) {
    let actions = <TripDetailModalActions>{
      confirm: (event: ButtonTriggerEvent) => {
      },
    };
    this.modalService.show({
      component: TripDetailModalComponent,
      providers: [
        {provide: TripDetailModalActions, useValue: actions},
        {
          provide: TripDetailModalData,
          useValue: new TripDetailModalData(item, displayingOn, this.hubName, null, null, isShowAddToTripBtn, index),
        },
      ],
      panelClass: ['width-modal-100p', 'ig-trip-info-modal'],
    });
  }

  public remove() {
  }
}



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/visitor/calendar/larger.card/visitor.larger.card.component.ts